import styled from "styled-components"

export const ImagePlaceholderBox = styled.div<{$placeholderBg: string}>`
  height: 34px;
  width: 34px;
  border-radius: 3.304px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${({ $placeholderBg }) => $placeholderBg};
  flex-shrink: 0;
  overflow: hidden;
`

export const MealImage = styled.img`
  border-radius: var(--spacing_xxs, 4px);
  object-fit: cover;
  width: 100%;
  height: 100%;
  overflow: hidden;
`
